import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-alert-expire-date-product-dialog',
  templateUrl: './alert-expire-date-product-dialog.component.html',
  styleUrls: ['./alert-expire-date-product-dialog.component.css']
})
export class AlertExpireDateProductDialogComponent implements OnInit {

  innerHeight: number = window.innerHeight;


  basket: any[] | any;

  changedProds: any[];

  productsToDeletetoBasket: any = [];
  url: string = this.router.url;

  constructor(

    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<AlertExpireDateProductDialogComponent>,
    private panierMan: PanierService,
    private tools: ToolsService,
    private router: Router
  ) {
    this.changedProds = data.errProductValidity.ids_notmatched;

  }


  ngOnInit() {

    this.getPanier();

  }




  getPanier() {


    this.basket = this.tools.getStor(PanierService.TAG_STORAGE);
    this.findProductinbasket();


  }
  /**
 * @description  find Product in a basket
 */
  findProductinbasket() {



    this.basket.map((products: any) => {



      let productchanged_ =[];
      let productDetailschanged_ = [];
      let productSubDetailschanged_ = [];

    let  productchanged = this.changedProds.find((value: any) => (value == products.id));


      if (productchanged) {
        products.dateChange = true;
        productchanged_.push(productchanged);
      }

      if (products.details && products.details.length > 0) {

        products.details.map((det: any) => {

        let  productDetailschanged = this.changedProds.find((value: any) => (value == det.id));

          if (productDetailschanged) {
            det.dateChange = true;
            productDetailschanged_.push(productDetailschanged);
          }

          if (det.details && det.details.length > 0) {
            det.details.map((sdet: any) => {
         let     productSubDetailschanged = this.changedProds.find((value: any) => (value == sdet.id));
              if (productSubDetailschanged) {
                sdet.dateChange = true;
                productSubDetailschanged_.push(productSubDetailschanged);
              }
            });
          }

        })
      }

      if (productSubDetailschanged_.length>0 || productDetailschanged_.length>0 || productchanged_.length>0) {

        this.productsToDeletetoBasket.push(products);
      }
    })



     this.removeProdBasket();
  }

  /**
  * @description  remove Product in  basket
  */

  removeProdBasket() {


    for (let i = 0; i < this.productsToDeletetoBasket.length; i++) {
      let unavailableProd = this.productsToDeletetoBasket[i];

      for (let j = 0; j < this.basket.length; j++) {
        let basketProd = this.basket[j];

        if (basketProd.id === unavailableProd.id) {
          this.basket.splice(j, 1);
          --j;
        }

      }

    }

    setTimeout(() => {
      this.panierMan.setPanier(this.basket);
    });

  }




  closeDial() {
    let splitUrl = this.url.split("/");


     if((!this.basket ||  this.basket &&  this.basket.length==0)&& splitUrl[1] === 'endorder'){
      this.tools.goProductPage();
     }
    this.dialogRef.close();


  }



}
